function openPopup() {
            var popup = document.getElementById("popup");
            popup.style.display = "block";

            var shade = document.getElementById("shade");
            shade.style.display = "block";
        
            document.addEventListener("click", closePopupOutside);
        }

        function closePopupOutside(event) {
            var popup = document.getElementById("popup");
            if (!popup.contains(event.target)) {
                popup.style.display = "none";
                document.removeEventListener("click", closePopupOutside);
            }

           
        }

//############################ Autoship

$(function()
{
    $(window).bind('load', function()
    {
        // Your code
    });
});
      
        function show_hide_date()
          {
            $("#shipment_date").show();
          }
        function calculate_auto_date()
          {
         
         $.get( "https://dashboard.laballey.com/v2/date_data.php", { sch: $("#sch").val(), cdate: $("#shipment_date").val() } )
        .done(function( data ) {
         //  alert("test");
          $("#shipment_date").hide();
         $("#update_cus").html(data);
        });
              }
   
function runonselect() {
        var sch=$("#sch").val();
        if(sch == "WEEK-1")
        $("#prsch").html("Every 1 Week");  
        if(sch == "WEEK-2")
        $("#prsch").html("Every 2 Weeks"); 
         if(sch == "WEEK-3")
        $("#prsch").html("Every 3 Weeks"); 
         if(sch == "WEEK-4")
        $("#prsch").html("Every 4 Weeks"); 
        if(sch == "WEEK-5")
        $("#prsch").html("Every 5 Weeks"); 
        if(sch == "WEEK-6")
        $("#prsch").html("Every 6 Weeks"); 

       if(sch == "WEEK-6")
        $("#prsch").html("Every 6 Weeks"); 

   if(sch == "WEEK-7")
        $("#prsch").html("Every 7 Weeks"); 

   if(sch == "WEEK-8")
        $("#prsch").html("Every 8 Weeks"); 

   if(sch == "WEEK-9")
        $("#prsch").html("Every 9 Weeks"); 


   if(sch == "WEEK-10")
        $("#prsch").html("Every 10 Weeks"); 

   if(sch == "WEEK-11")
        $("#prsch").html("Every 11 Weeks"); 


   if(sch == "WEEK-12")
        $("#prsch").html("Every 12 Weeks"); 

    }
   
$(document).ready(function() {

  $("#prtitle").html($("[itemprop='name']").text());

  $('a[href^="#"]').click(function() {
      var target = $(this.hash);
      if (target.length == 0) target = $('a[id="' + this.hash.substr(1) + '"]');
      if (target.length == 0) target = $('html');
      $('html, body').animate({ scrollTop: target.offset().top-110 }, 1000);
      // return false;
  });
  
   $(".quantity-selector-auto__button.1").click(function(){
     setqty_auto(2,1);
   });  
   $(".quantity-selector-auto__button.2").click(function(){
     setqty_auto(1,1);
   });  

  
   if ($(window).width() < 641) {
      $( "#prcies" ).appendTo(".product-form__variants");
   }  

   if ( $( ".faq-q" ).length == 0 ) {
      $( "<h2>Product Specifications</h2>" ).addClass('faq-q').prependTo(".table-wrapper");
   }
  
   $( ".productbutton.but-Cases" ).insertBefore(".productbutton.but-Pallet");

   $('#fullprice').html($('.current.selected .price').find('.pgs').html());  
  
   $( "#addblock" ).appendTo(".autoship-text.selected");
   if ($( document ).width() < 641) {
      $( "#prcies" ).appendTo(".product-form__variants");
   }  

   $( "#shopify-section-template--18208658227355__171516045307bf024f" ).appendTo(".productdescription");
   $( "#askQuestion1" ).appendTo(".oke-qw-header-askQuestion");


   $( ".simpQuestionHolder" ).addClass('faq-q');  
   $( ".simpAnswerHolder" ).addClass('faq-a');  
   $( ".accordionSimpQA > ul > li" ).addClass('faq-section');  

   $('#manualstrigger').click(function(){
     $('.manualtab').addClass('active');
     $('.coacontent').removeClass('active');
     $('.coatab').removeClass('active');
     $('.manuals').addClass('active');
   });

   $('#coatrigger').click(function(){
     $(this).addClass('active');
     $('.coacontent').addClass('active');
     $('.manualtab').removeClass('active');
     $('.manuals').removeClass('active');
   });
  
   $('.coatab').click(function(){
     $(this).addClass('active');
     $('.coacontent').addClass('active');
     $('.manualtab').removeClass('active');
     $('.manuals').removeClass('active');
   });

  $('.manualtab').click(function(){
     $(this).addClass('active');
     $('.coacontent').removeClass('active');
     $('.coatab').removeClass('active');
     $('.manuals').addClass('active');
   });
  
   $('.table-wrapper h3').replaceWith(function() {
     return $("<h4>", {
       class: this.className,
       html: $(this).html()
     });
   });
   
  $( ".singleproduct" ).css("opacity", "1");

  
$(".productsize").on('click', function() {
  
  var optionSelected = $(this);	
  $(".product").hide();	 
  $(".ideal .button").removeClass('active');
  optionSelected.addClass('active');
  id = optionSelected.prop('id');
  $('.but-' + id).show();	

  if( optionSelected.attr('image').length > 0 ) {
  	 image = optionSelected.attr('image');
    
    $('.product-single__photo').addClass('hide');
    $('#FeaturedImageZoom-product-template-' + image).removeClass('hide');
    $('#FeaturedImageZoom-product-template-single-' + image).removeClass('hide');
  }  
  
}); 

  attrid = $('#variant-dropdown.mobile-only option:selected').attr('id'); 

  // $('.mobile-only #variant-selector option').each(function() {
  //     if ($(this).hasClass(attrid)) {
  //       $(this).show();
  //     } else {
  //       $(this).remove();
  //     }
      
  // }); 
  
  if (attrid == 'but-Cases') {
       $('.mobile-only #variant-selector .but-single').remove();
       $('.mobile-only #variant-selector .but-Pallets').remove();
  } else {
       $('.mobile-only #variant-selector .but-Cases').remove();
  }
    
  
  $( ".prodsize" ).each(function( index ) {
    id = $(this).prop('id');
    
    $('.button.' + id).each(function(i, e) {
      if (i > 0) {
        $(this).remove();
      }
    });    
    
  });  	

  $( ".ideal .products_grouped .button" ).each(function( index ) {
    id = $(this).prop('id');
    
    $('.button.' + id).each(function(i, e) {
      if (i > 0) {
        if($(this).hasClass('active')) {
          $('.button.' + id).addClass('active');
        }  
        $(this).remove();
      }
    });    
    
  });  	
   

      $('#popup').appendTo('.singleproduct');
  $("#can_autoship").click(function(){
    var popup = document.getElementById("popup");
    popup.style.display = "none";
    $('.shade').show();
}); 
  $(".shade").click(function(){
    $('.shade').hide();
  }); 
  $("#popup").click(function(){
    $('.shade').hide();
  }); 
  $("#popup .button").click(function(){
    $('.shade').hide();
    $('#popup').hide();
  }); 
  
        
      $("#prsch").html("Every 4 Weeks"); 
      $('#autoship').prop('checked', false);  
     // $('.product.selected').addClass('current');  

      
      //$('.autoholder').appendTo('.selected.product.block-swatch');
      $('#fullprice').html($('.current.selected .price').find('.pgs').html());  
      $('#autoshipprice').html($('.current.selected .price').find('.autoprice').html());  
      $('#fullpricetop').html($('#fullprice').parent().parent().parent().find('.pgs').html());  
      
      
      $('#autoship').change(function() {
        if(this.checked) {
        
        $("#sch").attr('name', 'properties[_sch]');
        $("#shipment_date").attr('name', 'properties[_shipment_date]');
       
        $("#rest_opt").show();
 //       $(".pgs").hide();
 //       $(".pgs_show").show();
        } else {
        $("#sch").attr('name', '_nodata');
        $("#shipment_date").attr('name', '_nodata');
         $("#rest_opt").hide(); 
 //        $(".pgs").show();
 //       $(".pgs_show").hide();
        }
       
    });

    $('.autoship-text.two').click(function(e) {
      
      $(this).find('input').prop( "checked", true );
      $('.autoship-text').removeClass('selected');
      if($(this).find('input').val() == "single") {
        $('#autoship').prop('checked', false);
        $(".pgs").show();
        $(".pgs_show").hide();
         $("#sch").attr('name', '_nodata');
        $("#shipment_date").attr('name', '_nodata');
        $(this).addClass('selected');
        $('.button-auto').prop("disabled", true);
        $('.button-one').removeAttr('disabled');
        $("#qty2").attr("name", "quantity2");
      } else {
        $('#autoship').prop('checked', true);
        $(".pgs").hide();
        $(".pgs_show").show();
          $("#sch").attr('name', 'properties[_sch]');
        $("#shipment_date").attr('name', 'properties[_shipment_date]');
        $('.button-one').prop("disabled", true);
        $('.button-auto').removeAttr('disabled');
        $(this).addClass('selected');
        $("#qty2").attr("name", "quantity");
      }
//      $( "#addblock" ).appendTo(".autoship-text.selected");
    });    


   
      
    // date picker plugin #########################################################

      $("#shipment_date").flatpickr({
        
    minDate: new Date().fp_incr(3), 
    enableTime: false,
    dateFormat: "m/d/Y",
    "disable": [
        function(date) {
           return (date.getDay() === 0 || date.getDay() === 6);  // disable weekends
        }
    ],
    "locale": {
        "firstDayOfWeek": 1 // set start day of week to Monday
    }
});
   //##############################################################################   
  
   function setqty_auto(type,val)
     {
       $("#qty2").attr("name", "quantity");
       if(type == 1)
       {
         var i = parseInt($("#qty2").val()) + 1;
         $("#qty2").val(i);
       }  
       else {
         var i = parseInt($("#qty2").val()) - 1;
         if(i < 1)
         $("#qty2").val(1);
         else
         $("#qty2").val(i);
       }
     }

//############################ End Autoship

//############################ Product Variant Selector


$('.productbutton').click(function() {
       $('.product').removeClass('selected');
    
    });
    $('#product-variant-dropdown').on('change', function() {
             $('#fullprice').html($('option:selected', this).attr('pgs'));
             $('#fullpricetop').html($('option:selected', this).attr('pgs')); 
             $('#autoshipprice').html($('option:selected', this).attr('autoprice'));
    });
    $('.block-swatch__radio').click(function() {
         if(this.checked) { 
           
             $(this).parent().parent().parent().find('.product').removeClass('current');
             $(this).parent().addClass('current');
             // $('.product .autoholder').remove();
             // $('.autoholder').appendTo($(this).parent());
             $('#fullprice').html($(this).parent().find('.pgs').html());
             $('#fullpricetop').html($(this).parent().find('.pgs').html()); 
             $('#autoshipprice').html($(this).parent().find('.autoprice').html());
         }
      });
          
    });

      $('.product[image=' + vid + ']').addClass('selected');
      
      $('.product[image=' + vid + ']').find('input').click();



   function onqtyupdate() {
       $("#prqty").html($("#qty2").val());
    }                 
                    
function sve(vid,sku)
  {
    
      vid;
      sku;

   
  }
  function saveit(vid,sku)
    {
      
      vid;
      sku;
      
    $('#fullprice').html($('.current.selected .price').find('.pgs').html());  
    $("#prqty").html($("#qty").val());

    freeship_check(sku);  
      
    $.get( "https://dashboard.laballey.com/ajax.php", { sku:sku, id: vid } )
  .done(function( data ) {
    
   const myArray = data.split("|");
    let title= myArray[0];
    let option=myArray[1];
    $("#prtitle").html(title);
    $("#proption").html(option);
    
    
    

  });

      $('.product[image=' + vid + ']').addClass('selected');
      
      $('.product[image=' + vid + ']').find('input').click();
      $('.but-' + sku).show();
    
    }
  function addBogo_nnn()
    {
     let buy='33512108458043,33512108490811,33512108556347,33512108523579,33512108621883';
      const xp = buy.split(",");
   var variant_id=$("#bogo_vid").val();
      let pk=xp.includes(variant_id);
      //alert(pk);
      if(pk == true)
      {
      
        jQuery.post("/cart/add.js", {
  quantity:1,id:33512108490811
});
       //$("#qty").val(2);  
      }
      else
      {
        
      } 
    }
    function check_pos()
  {
    alert("More than 1lb can only be shipped to a commercial address, lab, or school. We cannot ship any quantity to an apartment.");
  }
 
  $('#cartpost').on('click', function(e){
    if($('#autoship').is(':checked'))
{
  e.stopPropagation();
   return false; 
}else
{
 
}
  
});


  function addcheck_auto()
    {
      if($('#autoship').is(':checked'))
{  
   openPopup();
  
}
      
    }
  
 $('#noautoship').on('click', function(e){
   $("#autoship").prop("checked", false);
    $("#sch").attr('name', '_nodata');
    $("#shipment_date").attr('name', '_nodata');
   
  
});

//############################ End of Product Variant Selector

function freeship_check(sku) {
    $.ajax({
    url: "https://dashboard.laballey.com/free_ship_flag.php", // Base URL
    type: "GET",
    data: { sku: sku }, // Attach the 'sku' parameter
    dataType: "json", // Expecting a JSON response
    success: function (response) {
        if (response.status === 1) {
           $( "<span class='freeship'><b>FREE</b> Ground Shipping!</span>" ).appendTo("#fullpricetop");
        } else if (response.status === 0) {
            
        } else {
            
        }
    },
    error: function (xhr, status, error) {
    }
  });
}

